export const calcDate = (date1, date2) => {
  var date3 = date2 - date1

  var days = Math.floor(date3 / (24 * 3600 * 1000))

  var leave1 = date3 % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000))

  var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000))

  var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var seconds = Math.round(date3 / 1000)
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  }
}

export function dateY(timestamp){
  if(!timestamp){
      return ''
  }
 var unixtimestamp = new Date(timestamp);
  var year = 1900 + unixtimestamp.getYear();
  var month = "0" + (unixtimestamp.getMonth() + 1);
  var date = "0" + unixtimestamp.getDate();
  var hour = "0" + unixtimestamp.getHours();
  var minute = "0" + unixtimestamp.getMinutes();
  var second = "0" + unixtimestamp.getSeconds();
  return year + "-" + month.substring(month.length-2, month.length)  + "-" + date.substring(date.length-2, date.length)
      + " " + hour.substring(hour.length-2, hour.length) + ":"
      + minute.substring(minute.length-2, minute.length) + ":"
      + second.substring(second.length-2, second.length);
}

export function getDateStr(today, addDayCount,type) {
  var dd;
  if (today) {
    dd = new Date(today);
  } else {
    dd = new Date();
  }
  dd.setDate(dd.getDate() + addDayCount);//获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1;//获取当前月份的日期
  var d = dd.getDate();
  if (m < 10) {
    m = '0' + m;
  };
  if (d < 10) {
    d = '0' + d;
  };
  if(type==1){
    return y + "年" + m + "月" + d+'日';
  }else{
    return y + "-" + m + "-" + d;
  }

}
export function dateSplit(timestamp,type){
  if(!timestamp){
      return ''
  }
  var date=''
  var d = new Date(timestamp);    //根据时间戳生成的时间对象
  var year= d.getFullYear();
  var mm = d.getMonth()+1;
  var dd = d.getDate();
  var hh = d.getHours();
  var mi = d.getMinutes();
  var ss = d.getSeconds();
  mm = mm>9?mm:'0'+mm;
  dd = dd>9?dd:'0'+dd;
  hh = hh>9?hh:'0'+hh;
  mi = mi>9?mi:'0'+mi;
  ss = ss>9?ss:'0'+ss;

  if(type==1){
     date = ' '+ hh + ':' + mi + ':'  + ss;
  }else if(type==2){
    date= year +'-'+mm+'-'+dd+' '+hh + ':' + mi + ':'  + ss;
  }else if(type==3){
    date= year +'-'+mm+'-'+dd;
  }else if(type==4){
    date= mm+'-'+dd +' '+ hh + ':' + mi;
  }else if(type==5){
    date= year +'年'+mm+'月'+dd+'日';
  }
  return date

}
